import React from 'react';

const Separator = () => {
  return (
    <div className="spikes"></div>  
  );
};

export default Separator;